import React from 'react';
import { useAppSelector } from 'src/hooks/useStore';
import { GetCurrentUser } from 'src/store/users/reducers';
import { FlagsContext } from 'src/context';
import { useMediaQuery, useTheme } from '@material-ui/core';

export const useSidebarCompanySwitcherVisibility = () => {
  const { EnableManyCompanies } = React.useContext(FlagsContext);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'));
  const currentUser = useAppSelector((state) =>
    GetCurrentUser({
      usersState: state.users,
      currentUserId: state.user.id,
      isClient: state.user.isClient,
    }),
  );
  return (
    EnableManyCompanies &&
    !isMobile &&
    (currentUser?.fields.companyIds?.length ?? 0) > 1
  );
};
